import axios from 'axios';
import { FormikProps } from 'formik';
import React, { useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, RootState } from 'shared';
import Swal from 'sweetalert2';
import * as Yup from "yup";
import { columnsUsersType } from '../types/columsUsers.types';

export const useFormUpdatePassword = (user: columnsUsersType) => {
    const dispatch = useDispatch<Dispatch>();
    const [isLoading, setIsLoading] = useState(false);
    const formikRef = useRef<FormikProps<any>>(null);
    const {userToken} = useSelector((state: RootState) => state.electronicDocuments);
    
    const initialValues = {
        password: '',
        confirmPassword: '',
    }
    const validationSchema = useMemo(()=>{
        return Yup.object().shape({
            password: Yup.string()
                .trim()
                .required('La contraseña es obligatoria')
                .min(12, 'La contraseña debe tener al menos 12 caracteres')
                .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])/,
                    'Debe contener mayúsculas, minúsculas, números y un carácter especial'
                ),
            confirmPassword: Yup.string().trim().required('La confirmación de la contraseña es obligatoria').oneOf([Yup.ref('password'), null], 'Las contraseñas no coinciden'),
        })
    },[])

  const handleSubmit = async (values: any ) => {
    setIsLoading(true);
     try {
        await axios.put(
          `${process.env.REACT_APP_OAUTH}/users/change-password/${user.id}`,
          {
            password: values.password,
            confirmPassword: values.confirmPassword,
          },
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
              'Content-Type': 'application/json',
             },
           }
          )
          setIsLoading(false);
          Swal.fire({
            icon: 'success',
            title: 'Usuario actualizado',
            text: 'La información se ha almacenado correctamente',
            confirmButtonText: 'Aceptar',
          }).then(() => {
            formikRef.current?.resetForm();
            dispatch.messageModal.cleanStateMessage();
          });
        } catch (error: any) {
            setIsLoading(false);
            Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error.response?.data?.message || 'Error al actualizar contraseña',
            });
        }
  };

  return {
      initialValues,
      formikRef,
      isLoading,
      validationSchema,
      handleSubmit,
  }
}
